import { api, endpoint } from '@/plugins/axios'

const getPendingLeaveApplications = async () => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.get(endpoint.LEAVE_PENDING, { params: { institutionId } })

  return res
}

const getLeaveReport = async params => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.get(endpoint.LEAVE_REPORT, { params: { institutionId, ...params } })

  return res
}

const approveLeaveApplication = async (leaveId, payload) => {
  const res = await api.put(`${endpoint.LEAVE}/${leaveId}/approve`, payload)

  return res
}

const rejectLeaveApplication = async (leaveId, payload) => {
  const res = await api.put(`${endpoint.LEAVE}/${leaveId}/reject`, payload)

  return res
}

export default {
  getPendingLeaveApplications,
  getLeaveReport,
  approveLeaveApplication,
  rejectLeaveApplication,
}
